import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { AlertProvider } from '../../providers/alert/alert';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { ProductDetailPage } from '../product-detail/product-detail';
import { CompleteInstallPage } from '../complete-install/complete-install';
import { DatePicker } from '@ionic-native/date-picker';
import swal from 'sweetalert';

@Component({
  selector: 'page-create-invoice',
  templateUrl: 'create-invoice.html',
})
export class CreateInvoicePage {
  order: { [k: string]: any } = {};
  finance : { [k: string]: any } = {};
  httpRunning = true;

  constructor(
    public navCtrl: NavController,

    public config: ConfigProvider,
    public navParams: NavParams,
    public http: Http,
		translate: TranslateService,
    public shared: SharedDataProvider,
    public alert: AlertProvider,
    public loading: LoadingProvider,
		public datePicker: DatePicker) {
    this.order = this.navParams.get('data');
    this.finance = [];
    //console.log(this.order);
  }

  sendInvoice(order){
    console.log("Sending Invoice:",order);

    this.loading.show();
   this.http.post(this.config.url + 'createInvoice', order).map(res => res.json()).subscribe(data => {
       this.loading.hide();


     if (data.success == 1) {
       console.log("Success");
       swal({title: "Success!",text: "Invoice has been sent",icon: "success"}).then((value) => {
       });
     }
     if (data.success == 0) { this.alert.show(data.message); }
   }, err => {
     swal({title: "Oops!",text: "Something went wrong. Try again later",icon: "error"}).then((value) => {
     });


   });
  }
	setInstallDateold(id){

		this.order.install_date = '2018-05-24';
		var data = this.order;
		//console.log("PostData:",data);


		this.http.post(this.config.url + 'setInstallDate', data).map(res => res.json()).subscribe(data => {
				this.loading.hide();


			if (data.success == 1) {
				console.log("Success");
			}
			if (data.success == 0) { this.alert.show(data.message); }
		}, err => {
		console.log("Error:")

		});

	}

ApproveQuote(id){

  var data = this.order;
  this.http.post(this.config.url + 'approveQuote', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();


    if (data.success == 1) {
      console.log("Success");
      swal({title: "Success!",text: "Another Quote Approved!",icon: "success"}).then((value) => {

      this.order.orders_status = "Approved";
      });

    }
    if (data.success == 0) { this.alert.show(data.message); }
  }, err => {
      this.alert.show("Something went wrong. Try again later");


  });

}

resendQuote(quote){
  console.log("Resend:",quote);
  var data = quote;
   this.loading.show();
  this.http.post(this.config.url + 'resendQuote', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();


    if (data.success == 1) {
      console.log("Success");
      swal({title: "Success!",text: "Quote has been resent",icon: "success"}).then((value) => {
      });
    }
    if (data.success == 0) { this.alert.show(data.message); }
  }, err => {
    swal({title: "Oops!",text: "Something went wrong. Try again later",icon: "error"}).then((value) => {
    });


  });


}

	setInstallDate(id){
		this.datePicker.show({
  date: new Date(),
  mode: 'date',
  androidTheme: this.datePicker.ANDROID_THEMES.THEME_HOLO_DARK
}).then(

	date => {
	this.order.install_date = date;
	 var data = this.order;
	 this.http.post(this.config.url + 'setInstallDate', data).map(res => res.json()).subscribe(data => {
			 this.loading.hide();


		 if (data.success == 1) {
			 console.log("Success");
		 }
		 if (data.success == 0) { this.alert.show(data.message); }
	 }, err => {
			 this.alert.show("Something went wrong. Try again later");


	 });

				},
	      err => console.log('Error occurred while getting date: ', err)
);

	}
    completeInstall(id) {
      console.log("Complete Install:",id);
            this.navCtrl.push(CompleteInstallPage, { data: id });
    }
  getSingleProductDetail(id) {
    this.loading.show();

    var data: { [k: string]: any } = {};
    if (this.shared.customerData != null)
      data.customers_id = this.shared.customerData.customers_id;
    else
      data.customers_id = null;
    data.products_id = id;
    data.language_id = this.config.langId;
    this.http.post(this.config.url + 'getAllProducts', data).map(res => res.json()).subscribe(data => {
      console.log("Data:",data);
      this.loading.hide();
      if (data.success == 1) {


        this.navCtrl.push(ProductDetailPage, { data: data.product_data[0] });
      }
    });
  }
  ionViewDidLoad() {
    this.order = this.navParams.get('data');
		console.log("Order Details:",this.order)
    if(this.order.quote_type == 'finance'){
   this.finance=JSON.parse(this.order.order_information);
   this.getFinanceStatus();
 }
  }

  ArchiveQuote(){

  }

  createInvoice(order){
    console.log("Create Invoice for:", order);
    this.navCtrl.push(CreateInvoicePage, { 'data': order });
  }

  getFinanceStatus() {
    this.httpRunning = true;


    this.loading.show();
    var data: { [k: string]: any } = {};
    data.phoenix_ref = this.order.phoenix_ref;
    console.log("Order:",this.order);
    this.http.post(this.config.url + 'getFinanceStatus', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      console.log("Got Response:",data.data);
      this.finance = data.data[0];
      //$rootScope.address=response.data.data;
      if (data.success == 1) {

      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error Please try again later");
        //console.log(response);
      });
  };

}



// WEBPACK FOOTER //
// ./src/pages/create-invoice/create-invoice.ts